import React, { FC } from 'react';
import { observer } from 'mobx-react-lite';
import { IGameEnvironment } from '../../../model/gameEnvironment/GameEnvironment';
import styles from './GameEnvironmentSelector.module.sass';
import { useRootStore } from '../../../loaders/useRootStore';
import { ButtonGroup, Form } from 'react-bootstrap';

interface PropsType {
    [key: string]: any,

    gameEnvironmentFilter?: (ge: IGameEnvironment) => boolean
    selectedGameEnvironment?: IGameEnvironment,
    handleGameEnvironmentChange?: (targetGE: IGameEnvironment) => void,
}

export const GameEnvironmentSelectorAsSelection: FC<PropsType> = observer(({
                                                                               gameEnvironmentFilter,
                                                                               selectedGameEnvironment,
                                                                               handleGameEnvironmentChange,
                                                                               onlyGameVersionEnabledEnvironment,
                                                                               className,
                                                                               ...props
                                                                           }) => {
    const rootStore = useRootStore();

    const changeGameEnvironment = (targetGE: string) => {
        const gameEnvironment = rootStore.gameEnvironmentsStore.gameEnvironments.find(gameEnvironment => gameEnvironment.id === Number.parseInt(targetGE));
        handleGameEnvironmentChange && handleGameEnvironmentChange(gameEnvironment as IGameEnvironment);
    };

    const selectedGameEnvironmentOrDefault = rootStore.gameEnvironmentsStore.getCurrentGameEnvironment().id;

    return (
        !(rootStore.gameVersionStore.getCurrentGameVersion().name.toLowerCase() === 'staticdata') &&
        <Form.Select align="end"
                     onChange={(e) => changeGameEnvironment(e.target.value)}
                     defaultValue={selectedGameEnvironmentOrDefault}
                     as={ButtonGroup}
                     className={`${styles.gameEnvSelector} ${className ?? ''}`}>
            {rootStore.gameEnvironmentsStore.gameEnvironments
                .filter(ge => gameEnvironmentFilter ? gameEnvironmentFilter(ge) : true)
                .map(env => {
                    return <option key={env.id} value={env.id}>{env.name}</option>;
                })}
        </Form.Select>
    );
});

